/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Link } from "react-router-dom";
import { Text, TEXT_VARIANTS } from "..";
import { COLORS } from "../../shared/theme";

export const EntityLink: React.FC<React.ComponentProps<typeof Link>> = ({
  children,
  ...props
}) => (
  <Link
    css={css`
      text-decoration: none;
    `}
    {...props}
  >
    <Text
      as="span"
      variant={TEXT_VARIANTS.T20BOLD}
      css={css`
        cursor: pointer;
        color: ${COLORS.SILVER};

        &:hover {
          color: ${COLORS.BLACK};
        }
      `}
    >
      {children}
    </Text>
  </Link>
);
